import { render, staticRenderFns } from "./RiskQnrResultsView.vue?vue&type=template&id=6c1218c6&scoped=true&"
import script from "./RiskQnrResultsView.vue?vue&type=script&lang=js&"
export * from "./RiskQnrResultsView.vue?vue&type=script&lang=js&"
import style0 from "./RiskQnrResultsView.vue?vue&type=style&index=0&id=6c1218c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1218c6",
  null
  
)

export default component.exports